import { Text, VStack, HStack } from '@ayble-health/dashboard-components';
import { Prescription } from 'api/types';

export const PrescriptionDetails = ({
  prescription,
}: {
  prescription: Prescription;
}) => {
  const { prescriber, pharmacy, refills, last_fill_date } = prescription;

  return (
    <HStack w={'100%'}>
      <VStack flex={1}>
        <Text
          color={'bluegrey'}
          textTransform={'uppercase'}
          fontWeight={'semibold'}
          fontSize={'xs'}
        >
          Prescriber
        </Text>
        <Text color={'evergreen'} fontSize={'xs'} fontWeight={'normal'}>
          {prescriber?.display_name}
        </Text>
        <Text color={'evergreen'} fontSize={'xs'} fontWeight={'normal'}>
          {prescriber?.care_member_category}
        </Text>
      </VStack>
      <VStack flex={1}>
        <Text
          color={'bluegrey'}
          textTransform={'uppercase'}
          fontWeight={'semibold'}
          fontSize={'xs'}
        >
          Pharmacy
        </Text>
        <Text color={'evergreen'} fontSize={'xs'} fontWeight={'normal'}>
          {pharmacy?.name}
        </Text>
        <Text color={'evergreen'} fontSize={'xs'} fontWeight={'normal'}>
          {pharmacy?.line1} {pharmacy?.line2}
        </Text>
      </VStack>
      <VStack flex={1}>
        <Text
          color={'bluegrey'}
          textTransform={'uppercase'}
          fontWeight={'semibold'}
          fontSize={'xs'}
        >
          Refills
        </Text>
        <Text color={'evergreen'} fontSize={'xs'} fontWeight={'normal'}>
          Total refills: {refills || '--'}
        </Text>
        <Text color={'evergreen'} fontSize={'xs'} fontWeight={'normal'}>
          Last filled: {last_fill_date || '--'}
        </Text>
      </VStack>
    </HStack>
  );
};

export default PrescriptionDetails;
